<template>
  <footer class="relative md:flex md:justify-between md:flex-row md:items-center">
      <div class="flex flex-row h-full w-full justify-between">
        <div class="flex flex-col justify-center links sm:w-full sm:justify-between mb-4 pl-5 sm:flex-row sm:items-center sm:mb-0">
          <a class="hover-text-grey text-white mb-4 block font-semibold text-xs sm:text-base sm:mb-0 sm:mr-5" href="https://www.kvernelandgroup.com" target="_BLANK">www.kvernelandgroup.com</a>
          <div class="flex flex-row">
            <a class="mr-2 lg:mr-4" href="https://www.youtube.com/kvernelandgrp" target="_BLANK">
              <img class="hover-filter-brightness w-6 h-6 lg:w-8 lg:h-8" src="@/assets/socials/youtube_logo.png" />
            </a>
            <a class="mr-2 lg:mr-4" href="https://www.facebook.com/KvernelandGroup/" target="_BLANK">
              <img class="hover-filter-brightness w-6 h-6 lg:w-8 lg:h-8" src="@/assets/socials/facebook_logo.png" />
            </a>
            <a class="mr-2 lg:mr-4" href="https://instagram.com/kverneland_ien" target="_BLANK">
              <img class="hover-filter-brightness w-6 h-6 lg:w-8 lg:h-8" src="@/assets/socials/instagram_logo.png" />
            </a>
            <a class="mr-2 lg:mr-4" href="https://www.linkedin.com/company/kverneland-group/" target="_BLANK">
              <img class="hover-filter-brightness w-6 h-6 lg:w-8 lg:h-8" src="@/assets/socials/linkedin_logo.png" />
            </a>
            <a class="" href="https://twitter.com/kvernelandgroup" target="_BLANK">
              <img class="hover-filter-brightness w-6 h-6 lg:w-8 lg:h-8" src="@/assets/socials/twitter_logo.png" />
            </a>
          </div>
        </div>
      <div class="flex flex-row">
        <div class="bottom-border-white slant-footer flex md:block md:self-end"></div>
        <div class="left-border-white pr-3 pl-1 bg-white flex flex-col justify-center items-center brands sm:pl-2 md:flex-row 2xl:px-5">
          <img class="h-6 w-28 mb-2 sm:h-6 sm:w-28 md:mb-0 md:h-8 md:w-36 md:mr-4 2xl:h-10 2xl:w-40" src="@/assets/images/KVG_logo_footer.png" />
          <img class="h-8 w-22 sm:h-8 sm:w-18 md:h-10 md:w-20 2xl:h-12 2xl:w-24" src="@/assets/images/vicon_logo.png" />
        </div>
      </div>
    </div>
    <div class="personalize-management text-white absolute -top-10 left-0 p-2 rounded-t-md bg-green" @click="openPersonalizationMenu()">
      <p class="">Manage services</p>
    </div>
  </footer>
</template>

<style lang="scss" scoped >
  footer {
    height: 100px;
    background-color: #999900;
  }
  .bg-white {
    height: 100%;
    background-color: white;
  }
  .left-border-white {
    border-left: 2px solid #ffffff;
  }
  .bottom-border-white {
    border-bottom: 2px solid #ffffff;
  }
  .personalize-management {
    cursor: pointer;
  }
  @media(min-width: 640px) { // sm
    .links {
      width: 65%;
    }
  }
  @media(min-width: 768px) { // md
    .links {
      width: 60%;
    }
  }
  @media(min-width: 1280px) { // xl
    .links {
      width: 70%;
    }
  }
  @media(min-width: 1536px) { // 2xl
    .links {
      width: 75%;
    }
  }
  @media(min-width: 2560px) { // 4xl
    .links {
      width: 80%;
    }
  }
  @media(min-width: 3840px) { // 5xl
    .links {
      width: 85%;
    }
  }
</style>

<script>
export default {
  name: 'app-footer',
  methods: {
    openPersonalizationMenu () {
      document.getElementById('cookie-personalization').classList.remove('hidden')
    }
  }
}
</script>